<template>
<!-- 数据中心项目/机房监控 -->
<div class="fc">
  <topbar :dataHeader="responseData.topBar"></topbar>
  <topbar-base ></topbar-base>
  <div class="pr wf hf mt-20">
    <transition name="left-side">
      <com-left :resData="responseData" />
    </transition>
    <com-center class="comCenter" :resData="responseData" />
    <transition name="right-side">
      <com-right :resData="responseData" />
    </transition>
  </div>
</div>
</template>

<script>
import screenAdjustMixin from '@/views/mixin/screenAdjustMixin'
import topbar from './topbar'
import comLeft from './left'
import comCenter from './center'
import comRight from './right'
import API from "@/api/sascreen-api.js"
import topbarBase from "../components/topbar-base"

export default {
  name: 'enterprise-security',
  components: {
    topbarBase,
    topbar,
    comLeft,
    comCenter,
    comRight
  },
  mixins: [ screenAdjustMixin ],
  data () {
    return {
      dcName: 'hami-a',
      responseData: {
        topBar: {},
        // Left
        onlineUsageRate: [],
        compUsage: {},
        taskType: [],
        appType: [],
        // Center
        dcInfo: {},
        dcStatistics: {},
        chipDistribution: {},
        energyData: {},
        energyPUE: {},
        energyPower: {},
        warningList: [],
        // Right
        networkStorage: [],
        envEvent: [],
        videoAlarm: {},
        networkSecurity: {},
      },
    }
  },
  mounted () {
    this.viewIndex()
    setInterval(() => {
      // API.getMonitordata({module: 'hamiIndex', key:'allUsage'}).then(data => {
      //   this.responseData.allUsage = JSON.parse(data.data.data.allUsage);
      // })
    }, 10000)
  },
  methods: {
    viewIndex () {
      const keys=
        'topBar, onlineUsageRate, compUsage, taskType, appType,' +
        'dcInfo, dcStatistics, chipDistribution, energyData, energyPUE, energyPower, warningList,' +
        'networkStorage, envEvent, videoAlarm, networkSecurity'

      API.getMonitordata({ module: 'dc', key: keys, param: this.dcName }).then(data => {
        this.responseData = data.data.data
        console.log('#dc#', this.responseData)
      })
    }
  }
}
</script>
<style>

</style>
